import { useEffect } from "react";
import { PackageInformation } from "src/models";
import { _ } from "src/services";
import LazyLoad from "vanilla-lazyload";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";
import { useSelector } from "react-redux";
import { ConfigInit } from "src/store";
import { Link } from "react-router-dom";

export const ProfileSitePackageBox: React.FC<PackageInformation> = ({
    id, image, purchaseType, title, description
}) => {

    const config: ConfigInit = useSelector((state: any) => state.ConfigState);

    useEffect(() => {
        const lazyload = new LazyLoad({
            elements_selector: ".lazy.p" + id,
            callback_error: (element: HTMLElement) => {
                const placeholder = element.getAttribute("data-placeholder");
                if (placeholder) element.setAttribute("src", placeholder);
            }
        });

        lazyload.update();

    }, [id]);


    return (
        <div className="profile-package">
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <img alt="" data-src={image}
                        data-placeholder={phPackage}
                        src={phPackage}
                        className={`package-logo lazy p${id}`} />
                    <h2 className="package-title">
                        <span>{title}</span>
                    </h2>
                </div>
                <div className="flex-1"></div>
                {
                    config.config.appSetting.isPackagingSystemEnabled &&
                    <Link className="btn btn-packages" to={`/subscription/${id}`}>{purchaseType === "renew" ? _("renew") : _("selectAndContinue")} </Link>
                }
            </div>
            <ul className="description">
                {description.map((x, index) => <li key={index}>{x}</li>)}
            </ul>
        </div>

    );

};